import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link,useNavigate } from 'react-router-dom';
import "../styles/OperationalsDiagnostic.css";


const downloadPDF = () => {
  const link = document.createElement("a");
  link.href = "/Diagnostic-Guide.pdf";   // your file path
  link.download = "Diagnostic-Guide.pdf"; // file name for user
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const OperationalsDiagnostic = () => {
  return (
    <>
      <Navbar />
      {/* Before We Build Section */}
      <section id="diagnostic-content" className="pdf-wrapper">
        <div class="page-break">
            <section className="wc-before">
            <div className="wc-container">

                <p className="wc-tag">Operational Diagnostic for Food & Beverage Businesses</p>

                <h1 className="wc-before-title"><b>
                Before we build anything, we map reality.
                </b></h1>
               <section className="di-preview">

      {/* TOP SECTION */}
      <div className="diag-top">
        <div className="diag-week">
          <span>Week</span>
          <h2>1</h2>
        </div>

        <div className="diag-content">
          <h3>
            When every client first sees their real margins — across all 6 engagements
          </h3>
          <p>
            The diagnostic delivers operational clarity within the first week —
            every single time. Most founders describe it as the clearest picture
            they've ever had of their own business.
          </p>
        </div>
      </div>
        {/* </div> */}

      {/* </div> */}
    </section>

                <p className="wc-before-text">
                Most F&B businesses don’t need more advice.
                They need clear visibility into what’s actually broken —
                and what to fix first.
                </p>

                <p className="wc-before-subtext">
                That’s exactly what our Operational Diagnostic delivers.
                </p>

            </div>
            </section>


      <section className="diag-preview">

      {/* TOP SECTION */}
      {/* <div className="diag-top">
        <div className="diag-week">
          <span>Week</span>
          <h2>1</h2>
        </div>

        <div className="diag-content">
          <h3>
            When every client first sees their real margins — across all 6 engagements
          </h3>
          <p>
            The diagnostic delivers operational clarity within the first week —
            every single time. Most founders describe it as the clearest picture
            they've ever had of their own business.
          </p>
        </div>
      </div> */}

      {/* DESCRIPTION */}
      {/* <p className="diag-description">
        Most F&B businesses don’t need more advice. They need clear visibility
        into what's actually broken — and what to fix first. That's exactly what
        our Operational Diagnostic delivers.
      </p> */}

      {/* TITLE */}
      <h3 className="diag-title">What we diagnose</h3>

      {/* CARDS */}
      <div className="diag-grid">

        <div className="diag-card">
          <span>01</span>
          <h4>Cost & Margin Reality</h4>
          <p>
            Food cost, menu margin visibility, major leakage points,
            cost structure alignment with your concept.
          </p>
        </div>

        <div className="diag-card">
          <span>02</span>
          <h4>Operations & Workflow</h4>
          <p>
            Kitchen and service workflows, bottlenecks during peak hours,
            role clarity and execution gaps.
          </p>
        </div>

        <div className="diag-card">
          <span>03</span>
          <h4>People & Execution</h4>
          <p>
            How dependent results are on specific individuals,
            training maturity, risk points when staff changes.
          </p>
        </div>

        <div className="diag-card">
          <span>04</span>
          <h4>Data, POS & Reporting</h4>
          <p>
            Whether your numbers reflect reality, POS configuration issues, usefulness of current reports.
          </p>
        </div>

      </div>

    </section> 

     <section className="case-study3 sections3">
        <div className='client-type'>
          <div className="diagnostic-cta">
        
        
        {/* LEFT */}
        <div className="left">
          <span className="big">18% → 4%</span>
        </div>

        {/* RIGHT */}
        <div className="right">
          <h2>
            Inventory variance eliminated — Adda's Cloud Kitchen, Whitefield
          </h2>

          <p>
            3-brand operation fully systematised in 9 weeks. Food cost dropped 4.2 percentage points. Order fulfilment errors down 61%
          </p>

          {/* <p>
            Expansion to 8 locations confirmed.
          </p> */}
        </div>
        </div>

      </div>
    </section>

    
    <section className="diag2-section">
      <h3 className="diag-title">Before you decide</h3>
      <p className="aaaa">After 20 years in F&B, I've seen operators try every option below. Here's what each one actually delivers — and what it doesn't.</p>
  <div className="diag2-container">

    {/* TOP METRICS */}
    <div className="diag2-scroll">
  <div className="diag2-container">
    <div className="diag2-top">
      <div className="diag2-box">
        <h3>6/6</h3>
        <p>clients recovered the diagnostic fee within 4 weeks of first changes</p>
      </div>
      <div className="diag2-box">
        <h3>₹2.9L</h3>
        <p>average monthly margin recovered per engagement</p>
      </div>
      <div className="diag2-box">
        <h3>Week 1</h3>
        <p>when every client first sees their real operational picture</p>
      </div>
      <div className="diag2-box">
        <h3>20 yrs</h3>
        <p>of F&B operating experience behind every engagement</p>
      </div>
    </div>

    {/* HEADER */}
    <div className="diag2-table-header">
      <div className="diag2-col">Consultant <br />
        <span>Advise & present</span>
      </div>
      <div className="diag2-col diag2-title">
        FNBDATALAB
        <span>Operating Partner</span>
      </div>
      {/* <div className="diag2-col">Consultant <br />
        <span>Advise & present</span>
      </div> */}
      <div className="diag2-col">Software / POS<br />
        <span>Data & dashboards</span>
      </div>
      <div className="diag2-col">Trainer / Coach<br />
        <span>Skills & behaviour</span>
      </div>
    </div>

    {/* SECTION: DIAGNOSIS */}
    <h4 className="diag2-section-title">DIAGNOSIS</h4>

    {/* ROW 1 */}
    <div className="diag2-row">
      <div className="diag2-left">
        <h5>Finds where your margins are actually leaking</h5>
        <p>Cost, waste, pour loss, vendor gaps</p>
        <div className="diag2-cross">✕</div>
        <div className="diag2-muted">Not in scope</div>
      </div>
      <div className="diag2-highlight">✦ <br/>First diagnostic deliverable</div>
      <div className="diag2-muted">~ <br/>Rarely goes this deep</div>
      <div className="diag2-muted">~ <br/>Shows numbers — you interpret</div>
    </div>

    {/* ROW 2 */}
    <div className="diag2-row">
      <div className="diag2-left">
        <h5>Maps how operations actually run on the ground</h5>
        <p>Not theory — the real picture</p>
        <div className="diag2-cross">✕</div>
      </div>
      <div className="diag2-highlight">✦<br />Step 1 always</div>
      <div className="diag2-muted">~ <br/>Depends on scope</div>
      <div className="diag2-cross">✕</div>
    </div>

    {/* SECTION: IMPLEMENTATION */}
    <h4 className="diag2-section-title">IMPLEMENTATION</h4>

    {/* ROW 3 */}
    <div className="diag2-row">
      <div className="diag2-left">
        <h5>Builds the systems — doesn't just recommend them</h5>
        <p>Designed inside your real operation</p>
        <div className="diag2-cross">~ </div>
        <div className="diag2-muted">~Training only</div>
      </div>
      <div className="diag2-highlight">✦ <br/>Always. No exceptions.</div>
      <div className="diag2-muted">✕ <br />Gives you a report</div>
      <div className="diag2-muted">✕ <br />You implement it</div>
    </div>

    {/* ROW 4 */}
    <div className="diag2-row">
      <div className="diag2-left">
        <h5>Stays accountable until execution stabilises</h5>
        <p>Not time-boxed — outcome-accountable</p>
        <div className="diag2-cross">✕</div>
        <div className="diag2-muted">per session</div>
      </div>
      <div className="diag2-highlight">✦ <br/>Our standard</div>
      <div className="diag2-muted">✕<br />Contract ends</div>
      <div className="diag2-muted">✕ <br />Monthly subscription</div>
    </div>

    {/* SECTION: OUTCOMES */}
    <h4 className="diag2-section-title">OUTCOMES FOR YOUR BUSINESS</h4>

    {/* ROW 5 */}
    <div className="diag2-row">
      <div className="diag2-left">
        <h5>Reduces how dependent results are on you personally</h5>
        <p>Team runs on systems — not on your presence</p>
        <div className="diag2-cross">~ </div>
        <div className="diag2-muted">partially</div>
      </div>
      <div className="diag2-highlight">✦ <br/>Primary goal</div>
      <div className="diag2-cross">✕</div>
      <div className="diag2-cross">✕</div>
    </div>

    {/* ROW 6 */}
    <div className="diag2-row">
      <div className="diag2-left">
        <h5>Low-risk entry point before full commitment</h5>
        <p>Start with clarity — not a retainer</p>
        <div className="diag2-cross">~</div>
        <div className="diag2-muted"> Pay per session</div>
      </div>
      <div className="diag2-highlight">✦ <br/>₹15K–₹20K diagnostic</div>
      <div className="diag2-muted">✕ <br/>High upfront retainer</div>
      <div className="diag2-muted">~ <br/>Subscription lock-in</div>
    </div>

    {/* CTA */}
    <div className="diag2-footer">
      <p><b>
        The diagnostic tells you what others can’t — what’s broken and what to fix first.</b><br />
        Most operators describe it as the clearest picture they've ever had of their own business. You leave with certainty — whether you continue with us or not.
      </p>
      <Link to="/contact" className="nav-cta-btn">
                          Book a Fit Call
                        </Link>
    </div>
    </div></div>

  </div>
</section>  

 <section className="case-study2 sections2">
        <div className='client-type'>
          <div className="diagnostic-cta">
        
        
        {/* LEFT */}
        <div className="left">
          <span className="big2">+41%</span>
        </div>

        {/* RIGHT */}
        <div className="right">
          <h2>
            Banqueting contribution margin — Porcha Inn Hotel, Central Bengaluru
          </h2>

          <p2>
            Three outlets unified under single P&L for the first time. ₹5.8L recovered monthly. FSSAI compliance restored Week 4.
          </p2>

          
        </div>
        </div>

      </div>
    </section>
    <section className="diag3-section">

  {/* TOP SUCCESS BAR */}
  <div className="diag3-success">
    ✓ 6 out of 6 clients recovered the full diagnostic investment within 4 weeks of first changes.
  </div>

  {/* MAIN CARD */}
  <div className="diag3-card">

    {/* SMALL BADGE */}
    {/* <div className="diag3-badge">
      ✓ Investment recovered within 4 weeks — 6/6 clients
    </div> */}

    {/* PRICE */}
    <h2 className="diag3-price">₹15,000 – ₹20,000</h2>
    <p className="diag3-sub">Based on business size and complexity</p>

    {/* LIST */}
    <ul className="diag3-list">
      <li>Clear problem map — what's working, what's not</li>
      <li>Margin and cost leak visibility</li>
      <li>Workflow breakdown insights</li>
      <li>POS and reporting evaluation</li>
      <li>A clear, prioritised action roadmap</li>
    </ul>

    {/* BUTTONS */}
    <div className="diag3-buttons">
      
    
  

  </div><div className="cta-buttons">
    
        
                <Link to="/contact" className="btn-2">
                  Book a Fit Call
                </Link>
                <div className="download-btn" onClick={downloadPDF}>
      <span className="btn-text">↓ Download Our Diagnostic Guide</span>
  
      <span className="btn-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"
          />
        </svg>
      </span>
    </div>
    </div>
    </div>


  {/* TESTIMONIAL */}
  <div className="diag3-testimonial">

    <div className="diag3-stars">★★★★★</div>

    <p className="diag3-quote">
      "We had two locations and two completely different ways of operating. FNBDATALAB standardised everything — and then we found out we had 18 menu items that were actually losing us money every time we sold them."
    </p>

    <div className="diag3-user">
      <div className="diag3-avatar">AK</div>
      <div>
        <h4>A.K.</h4>
        <span>Founder · Amare By Love · Specialty Café Group · Bengaluru</span>
      </div>
    </div>

  </div>

</section>


            {/* Comparison Section */}
{/* <section className="wc-comparison">
  <div className="wc-container">

    <h2 className="wc-section-title"><b>
      What This Is (and What It’s Not)
    </b></h2>

    <div className="wc-compare-grid"> */}

      {/* NOT */}
      {/* <div className="wc-card wc-not">
        <h3 className="wc-sec-title">This is not:</h3>
        <ul>
          <li><span className="highlight">✕ </span>    A free consultation</li>
          <li><span className="highlight">✕</span> A sales pitch</li>
          <li><span className="highlight">✕</span> A generic audit or checklist</li>
        </ul>
      </div> */}

      {/* IS */}
      {/* <div className="wc-card wc-is">
        <h3 className="wc-sec-title">This is:</h3>
        <ul>
          <li><span className="highlight">✓</span> A structured, paid deep-dive into how your business actually runs</li>
          <li><span className="highlight">✓</span> A clarity exercise before decisions, investments, or changes</li>
          <li><span className="highlight">✓</span> The foundation for any serious operational improvement</li>
        </ul>
      </div>

    </div> */}

    {/* <div className="wc-highlight-box">
      Think of it as an MRI for your operations — before treatment begins.
    </div>

  </div>
</section> */}
        

        {/* Who This Is For Section */}
{/* <section className="wc-audience">
  <div className="wc-container">

    <h2 className="wc-section-title"><b>
      Who This Diagnostic Is For
    </b></h2>

    <p className="wc-audience-subtext">
      This diagnostic is designed for founders who are done guessing
      and ready for structure.
    </p>

    <ul className="wc-audience-list">
      <li className="diagnose-card">Restaurant owners, café founders, cloud kitchen operators</li>
      <li className="diagnose-card">Multi-outlet F&B businesses planning expansion</li>
      <li className="diagnose-card">Founders who feel busy but lack operational control</li>
      <li className="diagnose-card">Operators tired of firefighting and gut-based decisions</li>
    </ul> */}

    {/* <div className="wc-audience-subtext" >
      <p className="highlight">
        If you're looking for quick hacks or free advice, this is not for you.
      </p>
      <p className="highlight">
        If you want operational certainty and structure — it is.
      </p>
    </div>

  </div>
</section> */}



      {/* Hero Section
      <section className="wc-hero">
        <div className="wc-container">
          <p className="wc-tag">
            What Changes When Systems Are in Place
          </p>

          <h1 className="wc-title">
            When Structure Replaces Improvisation,
            Everything Changes
          </h1>
        </div>
      </section> */}
      

      {/* What We Diagnose */}
{/* <section className="diagnose-section">
  <div className="container">

    <h2 className="section-title"><b>What We Diagnose</b></h2>
    <p className="section-subtitle">
      We assess four critical layers of your business — the ones where most
      operational and margin problems are hiding.
    </p>

    <div className="diagnose-grid">

      <div className="diagnose-card">
        <div className="number">1</div>
        <h3 className="highlight"><b> Cost & Margin Reality</b></h3>
        <ul>
          <li>Food cost and menu margin visibility</li>
          <li>Major leakage points</li>
          <li>Cost structure alignment with your concept</li>
        </ul>
      </div> */}

      {/* <div className="diagnose-card">
        <div className="number">2</div>
        <h3 className="highlight"><b> Operations & Workflow Health</b></h3>
        <ul>
          <li>Kitchen and service workflows</li>
          <li>Bottlenecks during peak hours</li>
          <li>Role clarity and execution gaps</li>
        </ul>
      </div>

      <div className="diagnose-card">
        <div className="number">3</div>
        <h3 className="highlight"><b> People & Execution Dependence</b></h3>
        <ul>
          <li>How dependent results are on specific individuals</li>
          <li>Training and SOP maturity</li>
          <li>Risk points when staff changes</li>
        </ul>
      </div> */}

      {/* <div className="diagnose-card">
        <div className="number">4</div>
        <h3 className="highlight"><b> Data, POS & Reporting Integrity</b></h3>
        <ul>
          <li>Whether your numbers reflect reality</li>
          <li>POS configuration issues</li>
          <li>Usefulness of current reports and MIS</li>
        </ul>
      </div>

    </div>

    <div className="diagnose-footer">

      <p className="highlight">We don't judge. We map reality.</p>
    </div>

  </div>
</section> */}



        {/* How the Diagnostic Works */}
{/* <section className="diagnose-section">
  <div className="container">

    <h2 className="section-title"><b>How the Diagnostic Works</b></h2>
    <p className="section-subtitle">
      Three steps. No surprises. No pressure.
    </p>

    <div className="diagnose-card">
      <h4 className="a-highlight"><span className="highlight"><b>Step 1 — Fit Call (15–20 mins)</b></span></h4>
      <p><b>A short call to:</b></p>
      <ul className="diagnse-card li">
        <li>Understand your business context</li>
        <li>Confirm whether the diagnostic is appropriate</li>
        <li>Align on scope and expectations</li>
      </ul>
      <p ><b> No consulting. No advice dumping.</b></p>
    </div>

    <div className="app-highlight">
      <h4 className="a-highlight"><span className="highlight"><b>Step 2 — Operational Diagnostic (Paid)</b></span></h4>
      <p>Once aligned, we proceed with the diagnostic</p>
      <p><b>Format may include:</b></p>
      <ul className="diagnse-card li">
        <li>Structured data review</li>
        <li>Process walkthroughs</li>
        <li>Team and execution assessment</li>
        <li>Cost and reporting evaluation</li>
      </ul>
    </div>

    <div className="diagnose-card">
      <h4 className="a-highlight"><span className="highlight"><b>Step 3 — Diagnostic Outcome</b></span></h4>
      <p><b>You receive:</b></p>
      <ul className="diagnse-card li">
        <li>A clear problem map — what's working, what's not</li>
        <li>Priority areas to fix first</li>
        <li>A prioritized action roadmap</li> */}
      {/* </ul>
      <p><b>This gives you the confidence to:</b></p>
      <ul className="diagnse-card li">
        <li>Move forward with FNBDATALAB</li>
        <li>Or take informed action independently</li>
      </ul>
      <p><b>
        Either way, you leave with operational certainty.
      </b></p>
    </div>

  </div>
</section> */}

        {/* Investment Section */}
{/* <section className="investment-section">
  <div className="investment-card">

    <p className="investment-tagline">
      This is paid because it changes how you decide.
    </p>

    <h2 className="investment-title">Investment</h2>

    <div className="investment-price">
      ₹15,000 – ₹20,000
    </div>

    <p className="investment-note">
      (Based on business size and complexity)
    </p>

    <div className="investment-features">
      <h4>This fee reflects:</h4>
      <ul>
        <li>Time</li>
        <li>Depth</li>
        <li>Accountability</li>
        <li>Serious intent</li>
      </ul>
    </div>

    <p className="investment-footer">
      This diagnostic often uncovers issues that save far more than
      its cost within weeks.
    </p>

  </div>
</section> */}

            {/* Hero Section */}
      {/* <section className="diagnose-section">
        <div className="wc-container"> */}
          {/* <p className="wc-tag">
            What Changes When Systems Are in Place
          </p> */}

          {/* <h1 className="wc-title"><b>
            What Happens After the Diagnostic?
          </b></h1>
          <p className="w-ac">There is no pressure to continue</p>
          <p className="wc-ac"><b>If we believe FNBDATALAB can meaningfully help:</b></p>
            <p className="diagnose-card">We'll propose a structured engagement</p>
            <p className="wc-ac"><b>If not:</b></p>
            <p className="diagnose-card">We'll tell you honestly</p>
            <p className="w-ac">We don't chase retainers. We build long-term operating partnerships.</p>
        </div>

      </section> */}


      {/* Content Section */}
      <section className="wc-content">
        <div className="wc-container">
            <p className="wc-title"><b>Why We Charge for the Diagnostic</b></p>
          <div className="wc-block">
            <h3 className="diagnose-card">Good diagnosis takes experience</h3>
            {/* <p>You know where profit is made — and where it leaks.</p> */}
          </div>

          <div className="wc-block">
            <h3 className="diagnose-card">Free advice is rarely respected</h3>
            {/* <p>Operations hold even during peak hours.</p> */}
          </div>

          <div className="wc-block">
            <h3 className="diagnose-card">Serious businesses value structured insight</h3>
            {/* <p>Real operational signals replace guesswork.</p> */}
          </div>

          {/* <div className="wc-block">
            <h3>Growth Becomes Predictable</h3>
            <p>Scale without operational fragility or burnout.</p>
          </div> */}

          <div className="wc-insight">
            <p className="wc-highlight-box"><b>
              Doctors charge before treatment.<br />
               Architects charge before design.<br />
               We charge before rebuilding operations.
           </b> </p>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="wc-cta">
        <div className="wc-container">
          <h2><b>Ready to See What's Actually Happening in Your Business?</b></h2>
          <p>
            If your operations feel heavier than they should — the diagnostic is where clarity begins
          </p> */}
          {/* <a href="/diagnostic" className="wc-btn">
            Book a Fit Call
          </a> */}
          {/* <Link to="/contact" className="wc-btn">
              Book a Fit Call
            </Link> */}
          {/* <p className="wc-con"> We'll assess whether the Operational Diagnostic makes sense for your business</p>
        </div>
      </section> */}
      </div>
    </section>
      <Footer />
      
    </>
  );
};

export default OperationalsDiagnostic;
